module.exports = __webpack_public_path__ + "img/discovery_cn_hover.410b4457.png";